/*
 * Title: Rewards/RedeemTab.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Aside, Mobilefilter, MobileHead, MobilePointStats, Tabshead,Navigation, RedeemContent from components.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import { connect } from "react-redux";
import { numberFormat } from "@helpers/common";

type Props = {};
type MyState = {};
class MobilePointsAvailable extends React.Component<Props | any, MyState> {
  state: MyState = {};

  render() {
    const { points_redeemed } = this.props;
    return (
      <div className="-mx-3 lg:hidden">
        <div className="bg-tile h-[46px] w-full flex items-center justify-between px-5">
          <p className="text-[15px] font-semibold opacity-70 uppercase tile-inlay-primary">
            POINTS AVAILABLE
          </p>
           <p className="text-[18px] font-bold uppercase tile-inlay-primary">
            {numberFormat(points_redeemed)}
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ score }) => {
  return {
    points_redeemed: score.points_redeemed,
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/UserRedux");
  return {
    ...stateProps,
    addNewUserFlag: (flag: boolean) => {
      dispatch(actions.addNewUserFlag(flag));
    },
  };
};

export default connect(
  mapStateToProps,
  undefined,
  mergeProps
)(MobilePointsAvailable);
